export enum XpoFacetEnumFilterTexts {
  ShowAll = 'Show all items',
  ShowLess = 'Show less items',
};
